module.exports = __webpack_public_path__ + "img/sk.7fa373b.svg";